import Papa from 'papaparse';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import LogoutModal from '../LogoutModal';

import config from '../config';
const API = config.API_BASE;

function AdminDashboard() {
  const [activeTab, setActiveTab] = useState('students');
  const [students, setStudents] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [auditLogs, setAuditLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showAddStudent, setShowAddStudent] = useState(false);
  const [showAddEmployee, setShowAddEmployee] = useState(false);
  const [newStudent, setNewStudent] = useState({ name:'', gender:'', department:'', year:'', email:'' });
  const [newEmployee, setNewEmployee] = useState({ name:'', gender:'', department:'', designation:'', email:'', salary:'' });
  const [message, setMessage] = useState('');
  const [studentSearch, setStudentSearch] = useState('');
  const [employeeSearch, setEmployeeSearch] = useState('');
  const [studentDeptFilter, setStudentDeptFilter] = useState('');
  const [employeeDeptFilter, setEmployeeDeptFilter] = useState('');
  const navigate = useNavigate();
  const userId = sessionStorage.getItem('userId');
  const [bulkUploadType, setBulkUploadType] = useState('');
  const [bulkResults, setBulkResults] = useState(null);
  const [bulkLoading, setBulkLoading] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  const [deleteType, setDeleteType] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [profileType, setProfileType] = useState('');
  const [profileLoading, setProfileLoading] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  useEffect(() => {
    fetchStudents();
    fetchEmployees();
    fetchAuditLogs();
  }, []);

  const fetchStudents = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/students`);
      setStudents(res.data);
    } catch(e) { console.error(e); }
    setLoading(false);
  };

  const fetchEmployees = async () => {
    try {
      const res = await axios.get(`${API}/employees`);
      setEmployees(res.data);
    } catch(e) { console.error(e); }
  };

  const fetchAuditLogs = async () => {
  try {
    const res = await axios.get(`${API}/auditlogs`);
    const sorted = res.data.sort((a, b) => 
      new Date(b.timestamp) - new Date(a.timestamp)
    );
    setAuditLogs(sorted);
  } catch(e) { console.error(e); }
};

  const handleAddStudent = async () => {
  try {
    await axios.post(`${API}/students`, {
      name: newStudent.name,
      gender: newStudent.gender,
      department: newStudent.department,
      year: parseInt(newStudent.year),
      email: newStudent.email
    });
    setMessage('Student added successfully!');
    setShowAddStudent(false);
    setNewStudent({ name:'', gender:'', department:'', year:'', email:'' });
    fetchStudents();
  } catch(e) { setMessage('Error adding student'); }
};

  const handleAddEmployee = async () => {
  try {
    await axios.post(`${API}/employees`, {
      name: newEmployee.name,
      gender: newEmployee.gender,
      department: newEmployee.department,
      designation: newEmployee.designation,
      email: newEmployee.email,
      salary: parseInt(newEmployee.salary)
    });
    setMessage('Employee added successfully!');
    setShowAddEmployee(false);
    setNewEmployee({ name:'', gender:'', department:'', designation:'', email:'', salary:'' });
    fetchEmployees();
  } catch(e) { setMessage('Error adding employee'); }
};

  const handleLogout = () => {
    sessionStorage.clear();
    navigate('/');
  };

  const tabs = [
    { id: 'students', label: '👨‍🎓 Students', count: students.length },
    { id: 'employees', label: '👔 Employees', count: employees.length },
    { id: 'auditlogs', label: '📋 Audit Logs', count: auditLogs.length },
  ];

  const filteredStudents = students.filter(s => {
  const matchSearch = s.name?.toLowerCase().includes(studentSearch.toLowerCase()) ||
    s.studentId?.toLowerCase().includes(studentSearch.toLowerCase()) ||
    s.email?.toLowerCase().includes(studentSearch.toLowerCase());
  const matchDept = studentDeptFilter === '' || s.department === studentDeptFilter;
  return matchSearch && matchDept;
});

const filteredEmployees = employees.filter(e => {
  const matchSearch = e.name?.toLowerCase().includes(employeeSearch.toLowerCase()) ||
    e.employeeId?.toLowerCase().includes(employeeSearch.toLowerCase()) ||
    e.email?.toLowerCase().includes(employeeSearch.toLowerCase());
  const matchDept = employeeDeptFilter === '' || e.department === employeeDeptFilter;
  return matchSearch && matchDept;
});

const studentDepts = [...new Set(students.map(s => s.department).filter(Boolean))];
const employeeDepts = [...new Set(employees.map(e => e.department).filter(Boolean))];

const handleBulkUpload = (type, file) => {
  if (!file) return;
  setBulkLoading(true);
  setBulkResults(null);
  setBulkUploadType(type);

  Papa.parse(file, {
    header: true,
    skipEmptyLines: true,
    complete: async (results) => {
      const rows = results.data;
      let success = 0;
      let failed = 0;
      const errors = [];

      for (const row of rows) {
        try {
          if (type === 'students') {
            await axios.post(`${API}/students`, {
              name: row.name?.trim(),
              gender: row.gender?.trim(),
              department: row.department?.trim(),
              year: parseInt(row.year),
              email: row.email?.trim()
            });
          } else {
            await axios.post(`${API}/employees`, {
              name: row.name?.trim(),
              gender: row.gender?.trim(),
              department: row.department?.trim(),
              designation: row.designation?.trim(),
              email: row.email?.trim(),
              salary: parseInt(row.salary)
            });
          }
          success++;
        } catch(e) {
          failed++;
          errors.push(row.name || 'Unknown');
        }
      }

      setBulkResults({ success, failed, errors, total: rows.length });
      setBulkLoading(false);
      if (type === 'students') fetchStudents();
      else fetchEmployees();
    }
  });
};

const downloadTemplate = (type) => {
  const studentTemplate = `name,gender,department,year,email
Rahul Sharma,Male,CSE,3,rahul.sharma@amity.edu
Priya Singh,Female,ECE,2,priya.singh@amity.edu`;

  const employeeTemplate = `name,gender,department,designation,email,salary
Dr Rajesh Kumar,Male,CSE,Professor,rajesh.kumar@amity.edu,95000
Sunita Sharma,Female,HR,Manager,sunita.sharma@amity.edu,75000`;

  const content = type === 'students' ? studentTemplate : employeeTemplate;
  const filename = type === 'students' ? 'students_template.csv' : 'employees_template.csv';

  const blob = new Blob([content], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};

const handleDelete = async () => {
  try {
    if (deleteType === 'student') {
      await axios.delete(`${API}/students/${deleteConfirm.id}`);
      setMessage('Student deleted successfully');
      fetchStudents();
    } else {
      await axios.delete(`${API}/employees/${deleteConfirm.id}`);
      setMessage('Employee deleted successfully');
      fetchEmployees();
    }
    setDeleteConfirm(null);
    setDeleteType('');
  } catch(e) {
    setMessage('Error deleting record');
  }
};

const openProfile = async (id, type) => {
  setProfileLoading(true);
  setProfileType(type);
  setSelectedProfile(null);
  try {
    if (type === 'student') {
      const res = await axios.get(`${API}/students/${id}`);
      setSelectedProfile(res.data);
    } else {
      const res = await axios.get(`${API}/employees/${id}`);
      setSelectedProfile(res.data);
    }
  } catch(e) {
    console.error(e);
  }
  setProfileLoading(false);
};

  return (
    <div className="min-h-screen bg-slate-100">
      {/* Navbar */}
      <nav className="bg-slate-900 text-white px-6 py-4 flex items-center justify-between shadow-lg">
        <div className="flex items-center gap-3">
          <img src="/cloudrecords-logo.svg" alt="CloudRecords" className="w-8 h-8" />
          <div>
            <h1 className="font-bold text-lg leading-tight">CloudRecords</h1>
            <p className="text-xs text-slate-400">Admin Dashboard</p>
          </div>
        </div>
        <div className="flex items-center gap-4">
          <span className="text-sm text-slate-300">👤 {userId}</span>
         <button onClick={() => setShowLogoutModal(true)} className="bg-red-600 hover:bg-red-700 text-white text-sm px-4 py-2 rounded-lg transition">
  Logout
</button>
        </div>
      </nav>

      <div className="max-w-7xl mx-auto px-6 py-8">
        {/* Stats */}
        <div className="grid grid-cols-3 gap-6 mb-8">
          <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-200">
            <p className="text-slate-500 text-sm">Total Students</p>
            <p className="text-4xl font-bold text-blue-600 mt-1">{students.length}</p>
          </div>
          <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-200">
            <p className="text-slate-500 text-sm">Total Employees</p>
            <p className="text-4xl font-bold text-green-600 mt-1">{employees.length}</p>
          </div>
          <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-200">
            <p className="text-slate-500 text-sm">Audit Log Entries</p>
            <p className="text-4xl font-bold text-purple-600 mt-1">{auditLogs.length}</p>
          </div>
        </div>

        {/* Success message */}
        {message && (
          <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-xl mb-6 text-sm">
            {message}
          </div>
        )}

        {/* Tabs */}
        <div className="flex gap-2 mb-6">
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-5 py-2.5 rounded-xl text-sm font-medium transition ${
                activeTab === tab.id
                  ? 'bg-blue-600 text-white shadow'
                  : 'bg-white text-slate-600 hover:bg-slate-50 border border-slate-200'
              }`}
            >
              {tab.label} ({tab.count})
            </button>
          ))}
        </div>

        {/* Students Tab */}
        {activeTab === 'students' && (
          <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
            <div className="px-6 py-4 border-b border-slate-100 flex flex-wrap justify-between items-center gap-3">
              <h2 className="font-semibold text-slate-800">All Students</h2>
              {/* Bulk Upload Results */}
            {bulkLoading && bulkUploadType === 'students' && (
              <div className="px-6 py-4 bg-blue-50 border-b border-blue-100">
                <p className="text-sm text-blue-600">Uploading students... please wait</p>
              </div>
            )}
            {bulkResults && bulkUploadType === 'students' && (
              <div className={`px-6 py-4 border-b ${bulkResults.failed === 0 ? 'bg-green-50 border-green-100' : 'bg-yellow-50 border-yellow-100'}`}>
                <p className="text-sm font-medium text-slate-800">
                  Upload Complete: {bulkResults.success} of {bulkResults.total} students added successfully
                  {bulkResults.failed > 0 && ` (${bulkResults.failed} failed)`}
                </p>
                {bulkResults.errors.length > 0 && (
                  <p className="text-xs text-red-500 mt-1">Failed IDs: {bulkResults.errors.join(', ')}</p>
                )}
                <button onClick={() => setBulkResults(null)} className="text-xs text-slate-400 mt-1 hover:text-slate-600">Dismiss</button>
              </div>
            )}
              <div className="flex flex-wrap gap-2">
                <button
                  onClick={() => downloadTemplate('students')}
                  className="bg-slate-100 hover:bg-slate-200 text-slate-600 text-sm px-4 py-2 rounded-lg transition"
                >
                  Download Template
                </button>
                <label className="bg-green-600 hover:bg-green-700 text-white text-sm px-4 py-2 rounded-lg transition cursor-pointer">
                  Bulk Upload CSV
                  <input
                    type="file"
                    accept=".csv"
                    className="hidden"
                    onChange={(e) => handleBulkUpload('students', e.target.files[0])}
                  />
                </label>
                <button
                  onClick={() => setShowAddStudent(!showAddStudent)}
                  className="bg-blue-600 hover:bg-blue-700 text-white text-sm px-4 py-2 rounded-lg transition"
                >
                  + Add Student
                </button>
              </div>
            </div>

            {/* Add Student Form */}
            {showAddStudent && (
              <div className="px-6 py-4 bg-blue-50 border-b border-blue-100">
                <div className="grid grid-cols-2 gap-4">
                  {[
                    { key: 'name', placeholder: 'Full Name' },
                    { key: 'department', placeholder: 'Department (e.g. CSE)' },
                    { key: 'year', placeholder: 'Year (1-4)' },
                    { key: 'email', placeholder: 'Email Address' },
                  ].map(field => (
                    <input
                      key={field.key}
                      placeholder={field.placeholder}
                      value={newStudent[field.key]}
                      onChange={(e) => setNewStudent({...newStudent, [field.key]: e.target.value})}
                      className="px-4 py-2.5 border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-blue-500"
                    />
                  ))}
                </div>
                <button
                  onClick={handleAddStudent}
                  className="mt-4 bg-blue-600 hover:bg-blue-700 text-white text-sm px-6 py-2.5 rounded-lg transition"
                >
                  Save Student
                </button>
              </div>
            )}

            {/* Students Table */}

            {/* Search and Filter Bar */}
              <div className="px-6 py-4 border-b border-slate-100 flex flex-wrap gap-3">
                <input
                  type="text"
                  placeholder="Search by name, ID or email..."
                  value={studentSearch}
                  onChange={(e) => {
  setStudentSearch(e.target.value);
  setIsSearching(true);
  setTimeout(() => setIsSearching(false), 500);
}}
                  className={`flex-1 min-w-48 px-4 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-blue-500 ${isSearching ? 'search-active' : ''}`}
                />
                <select
                  value={studentDeptFilter}
                  onChange={(e) => setStudentDeptFilter(e.target.value)}
                  className="px-4 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-blue-500 bg-white"
                >
                  <option value="">All Departments</option>
                  {studentDepts.map(dept => (
                    <option key={dept} value={dept}>{dept}</option>
                  ))}
                </select>
                {(studentSearch || studentDeptFilter) && (
                  <button
                    onClick={() => { setStudentSearch(''); setStudentDeptFilter(''); }}
                    className="px-4 py-2 bg-slate-100 hover:bg-slate-200 text-slate-600 rounded-lg text-sm transition"
                  >
                    Clear
                  </button>
                )}
                <span className="px-3 py-2 text-sm text-slate-500 flex items-center gap-2">
  {isSearching && (
    <svg className="search-spinner w-4 h-4 text-blue-500" fill="none" viewBox="0 0 24 24">
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"/>
    </svg>
  )}
  {filteredStudents.length} of {students.length} students
</span>
              </div>

            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="bg-slate-50 text-slate-500 text-xs uppercase">
                  <tr>
                    <th className="px-6 py-3 text-left">Student ID</th>
                    <th className="px-6 py-3 text-left">Name</th>
                    <th className="px-6 py-3 text-left">Department</th>
                    <th className="px-6 py-3 text-left">Year</th>
                    <th className="px-6 py-3 text-left">Email</th>
                    <th className="px-6 py-3 text-left">Created</th>
                    <th className="px-6 py-3 text-left">Action</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100">
                  {loading ? (
                    <tr><td colSpan="6" className="px-6 py-8 text-center text-slate-400">Loading...</td></tr>
                  ) : filteredStudents.length === 0 ? (
                    <tr><td colSpan="6" className="px-6 py-8 text-center text-slate-400">No students found</td></tr>
                  ) : (
                  filteredStudents.map((s, i) => (
                  <tr key={i} className="hover:bg-slate-50 cursor-pointer transition" onClick={() => openProfile(s.studentId, 'student')}>
                    <td className="px-6 py-4 font-medium text-blue-600">{s.studentId}</td>
                    <td className="px-6 py-4">{s.name}</td>
                    <td className="px-6 py-4"><span className="bg-blue-100 text-blue-700 px-2 py-1 rounded-full text-xs">{s.department}</span></td>
                    <td className="px-6 py-4">Year {s.year}</td>
                    <td className="px-6 py-4 text-slate-500">{s.email}</td>
                    <td className="px-6 py-4 text-slate-400">{s.createdAt ? s.createdAt.split('T')[0] : '-'}</td>
                    <td className="px-6 py-4">
                      <button
                        onClick={() => { setDeleteConfirm({ id: s.studentId, name: s.name }); setDeleteType('student'); }}
                        className="text-red-500 hover:text-red-700 text-xs font-medium hover:underline transition"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Employees Tab */}
        {activeTab === 'employees' && (
          <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
            <div className="px-6 py-4 border-b border-slate-100 flex flex-wrap justify-between items-center gap-3">
            <h2 className="font-semibold text-slate-800">All Employees</h2>
            <div className="flex flex-wrap gap-2">
              <button
                onClick={() => downloadTemplate('employees')}
                className="bg-slate-100 hover:bg-slate-200 text-slate-600 text-sm px-4 py-2 rounded-lg transition"
              >
                Download Template
              </button>
              <label className="bg-blue-600 hover:bg-blue-700 text-white text-sm px-4 py-2 rounded-lg transition cursor-pointer">
                Bulk Upload CSV
                <input
                  type="file"
                  accept=".csv"
                  className="hidden"
                  onChange={(e) => handleBulkUpload('employees', e.target.files[0])}
                />
              </label>
              <button
                onClick={() => setShowAddEmployee(!showAddEmployee)}
                className="bg-green-600 hover:bg-green-700 text-white text-sm px-4 py-2 rounded-lg transition"
              >
                + Add Employee
              </button>
            </div>
          </div>

          {/* Bulk Upload Results */}
            {bulkLoading && bulkUploadType === 'employees' && (
              <div className="px-6 py-4 bg-green-50 border-b border-green-100">
                <p className="text-sm text-green-600">Uploading employees... please wait</p>
              </div>
            )}
            {bulkResults && bulkUploadType === 'employees' && (
              <div className={`px-6 py-4 border-b ${bulkResults.failed === 0 ? 'bg-green-50 border-green-100' : 'bg-yellow-50 border-yellow-100'}`}>
                <p className="text-sm font-medium text-slate-800">
                  Upload Complete: {bulkResults.success} of {bulkResults.total} employees added successfully
                  {bulkResults.failed > 0 && ` (${bulkResults.failed} failed)`}
                </p>
                {bulkResults.errors.length > 0 && (
                  <p className="text-xs text-red-500 mt-1">Failed IDs: {bulkResults.errors.join(', ')}</p>
                )}
                <button onClick={() => setBulkResults(null)} className="text-xs text-slate-400 mt-1 hover:text-slate-600">Dismiss</button>
              </div>
            )}

            {/* Add Employee Form */}
            {showAddEmployee && (
              <div className="px-6 py-4 bg-green-50 border-b border-green-100">
                <div className="grid grid-cols-2 gap-4">
                  {[
                    { key: 'name', placeholder: 'Full Name' },
                    { key: 'department', placeholder: 'Department' },
                    { key: 'designation', placeholder: 'Designation' },
                    { key: 'email', placeholder: 'Email Address' },
                    { key: 'salary', placeholder: 'Salary (e.g. 50000)' },
                  ].map(field => (
                    <input
                      key={field.key}
                      placeholder={field.placeholder}
                      value={newEmployee[field.key]}
                      onChange={(e) => setNewEmployee({...newEmployee, [field.key]: e.target.value})}
                      className="px-4 py-2.5 border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-green-500"
                    />
                  ))}
                </div>
                <button
                  onClick={handleAddEmployee}
                  className="mt-4 bg-green-600 hover:bg-green-700 text-white text-sm px-6 py-2.5 rounded-lg transition"
                >
                  Save Employee
                </button>
              </div>
            )}

            {/* Employees Table */}
            {/* Search and Filter Bar */}
<div className="px-6 py-4 border-b border-slate-100 flex flex-wrap gap-3">
  <input
    type="text"
    placeholder="Search by name, ID or email..."
    value={employeeSearch}
    onChange={(e) => {
  setEmployeeSearch(e.target.value);
  setIsSearching(true);
  setTimeout(() => setIsSearching(false), 500);
}}
    className={`flex-1 min-w-48 px-4 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-green-500 ${isSearching ? 'search-active' : ''}`}
  />
  <select
    value={employeeDeptFilter}
    onChange={(e) => setEmployeeDeptFilter(e.target.value)}
    className="px-4 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-green-500 bg-white"
  >
    <option value="">All Departments</option>
    {employeeDepts.map(dept => (
      <option key={dept} value={dept}>{dept}</option>
    ))}
  </select>
  {(employeeSearch || employeeDeptFilter) && (
    <button
      onClick={() => { setEmployeeSearch(''); setEmployeeDeptFilter(''); }}
      className="px-4 py-2 bg-slate-100 hover:bg-slate-200 text-slate-600 rounded-lg text-sm transition"
    >
      Clear
    </button>
  )}
  <span className="px-3 py-2 text-sm text-slate-500 flex items-center gap-2">
  {isSearching && (
    <svg className="search-spinner w-4 h-4 text-green-500" fill="none" viewBox="0 0 24 24">
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"/>
    </svg>
  )}
  {filteredEmployees.length} of {employees.length} employees
</span>
</div>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="bg-slate-50 text-slate-500 text-xs uppercase">
                  <tr>
                    <th className="px-6 py-3 text-left">Employee ID</th>
                    <th className="px-6 py-3 text-left">Name</th>
                    <th className="px-6 py-3 text-left">Department</th>
                    <th className="px-6 py-3 text-left">Designation</th>
                    <th className="px-6 py-3 text-left">Salary</th>
                    <th className="px-6 py-3 text-left">Email</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100">
                  {filteredEmployees.length === 0 ? (
                    <tr><td colSpan="6" className="px-6 py-8 text-center text-slate-400">No employees found</td></tr>
                  ) : (
                    filteredEmployees.map((e, i) => (
                  <tr key={i} className="hover:bg-slate-50 cursor-pointer transition" onClick={() => openProfile(e.employeeId, 'employee')}>
                    <td className="px-6 py-4 font-medium text-green-600">{e.employeeId}</td>
                    <td className="px-6 py-4">{e.name}</td>
                    <td className="px-6 py-4"><span className="bg-green-100 text-green-700 px-2 py-1 rounded-full text-xs">{e.department}</span></td>
                    <td className="px-6 py-4">{e.designation}</td>
                    <td className="px-6 py-4">₹{e.salary?.toLocaleString()}</td>
                    <td className="px-6 py-4 text-slate-500">{e.email}</td>
                    <td className="px-6 py-4">
                      <button
                        onClick={() => { setDeleteConfirm({ id: e.employeeId, name: e.name }); setDeleteType('employee'); }}
                        className="text-red-500 hover:text-red-700 text-xs font-medium hover:underline transition"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Audit Logs Tab */}
        {activeTab === 'auditlogs' && (
          <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
            <div className="px-6 py-4 border-b border-slate-100">
              <h2 className="font-semibold text-slate-800">Audit Logs</h2>
              <p className="text-xs text-slate-400 mt-1">Complete trail of all system actions</p>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="bg-slate-50 text-slate-500 text-xs uppercase">
                  <tr>
                    <th className="px-6 py-3 text-left">User ID</th>
                    <th className="px-6 py-3 text-left">Action</th>
                    <th className="px-6 py-3 text-left">Target</th>
                    <th className="px-6 py-3 text-left">Result</th>
                    <th className="px-6 py-3 text-left">Timestamp</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100">
                  {auditLogs.length === 0 ? (
                    <tr><td colSpan="5" className="px-6 py-8 text-center text-slate-400">No audit logs found</td></tr>
                  ) : (
                    auditLogs.map((log, i) => (
                      <tr key={i} className="hover:bg-slate-50">
                        <td className="px-6 py-4 font-medium text-purple-600">{log.userId}</td>
                        <td className="px-6 py-4"><span className="bg-purple-100 text-purple-700 px-2 py-1 rounded-full text-xs">{log.action}</span></td>
                        <td className="px-6 py-4">{log.targetId}</td>
                        <td className="px-6 py-4">
                          <span className={`px-2 py-1 rounded-full text-xs ${log.result === 'SUCCESS' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                            {log.result}
                          </span>
                        </td>
                        <td className="px-6 py-4 text-slate-400">{log.timestamp ? log.timestamp.replace('T', ' ').split('.')[0] : '-'}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>

      {/* Profile Modal */}
{(selectedProfile || profileLoading) && (
  <div
    className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4"
    onClick={() => setSelectedProfile(null)}
  >
    <div
      className="bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-screen overflow-y-auto modal-in"
      onClick={(e) => e.stopPropagation()}
    >
      {profileLoading ? (
        <div className="p-8 flex flex-col items-center gap-4">
          <div className="loader">
            <svg id="cloud" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
              <defs>
                <filter id="roundness2">
                  <feGaussianBlur in="SourceGraphic" stdDeviation="1.5"/>
                  <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 20 -10"/>
                </filter>
                <mask id="shapes2">
                  <g fill="white">
                    <polygon points="50 37.5 80 75 20 75 50 37.5"/>
                    <circle cx="20" cy="60" r="15"/>
                    <circle cx="80" cy="60" r="15"/>
                    <g>
                      <circle cx="20" cy="60" r="15"/>
                      <circle cx="20" cy="60" r="15"/>
                      <circle cx="20" cy="60" r="15"/>
                    </g>
                  </g>
                </mask>
                <mask id="clipping2" clipPathUnits="userSpaceOnUse">
                  <g id="lines" filter="url(#roundness2)">
                    <g mask="url(#shapes2)" stroke="white">
                      {[-40,-31,-22,-13,-4,5,14,23,32,41,50,59,68,77,86,95,104,113,122,131,140].map((y,i) => (
                        <line key={i} x1="-50" y1={y} x2="150" y2={y}/>
                      ))}
                    </g>
                  </g>
                </mask>
              </defs>
              <rect x="0" y="0" width="100" height="100" mask="url(#clipping2)"/>
              <g>
                <path d="M33.52,68.12 C35.02,62.8 39.03,58.52 44.24,56.69 C49.26,54.93 54.68,55.61 59.04,58.4 C59.04,58.4 56.24,60.53 56.24,60.53 C55.45,61.13 55.68,62.37 56.63,62.64 C56.63,62.64 67.21,65.66 67.21,65.66 C67.98,65.88 68.75,65.3 68.74,64.5 C68.74,64.5 68.68,53.5 68.68,53.5 C68.67,52.51 67.54,51.95 66.75,52.55 C66.75,52.55 64.04,54.61 64.04,54.61 C57.88,49.79 49.73,48.4 42.25,51.03 C35.2,53.51 29.78,59.29 27.74,66.49 C27.29,68.08 28.22,69.74 29.81,70.19 C30.09,70.27 30.36,70.31 30.63,70.31 C31.94,70.31 33.14,69.44 33.52,68.12Z"/>
                <path d="M69.95,74.85 C68.35,74.4 66.7,75.32 66.25,76.92 C64.74,82.24 60.73,86.51 55.52,88.35 C50.51,90.11 45.09,89.43 40.73,86.63 C40.73,86.63 43.53,84.51 43.53,84.51 C44.31,83.91 44.08,82.67 43.13,82.4 C43.13,82.4 32.55,79.38 32.55,79.38 C31.78,79.16 31.02,79.74 31.02,80.54 C31.02,80.54 31.09,91.54 31.09,91.54 C31.09,92.53 32.22,93.09 33.01,92.49 C33.01,92.49 35.72,90.43 35.72,90.43 C39.81,93.63 44.77,95.32 49.84,95.32 C52.41,95.32 55,94.89 57.51,94.01 C64.56,91.53 69.99,85.75 72.02,78.55 C72.47,76.95 71.54,75.3 69.95,74.85Z"/>
              </g>
            </svg>
          </div>
          <p className="text-sm text-slate-400 animate-pulse">Loading profile...</p>
        </div>
      ) : selectedProfile && (
        <>
          {/* Profile Header */}
          <div className={`p-6 rounded-t-2xl ${profileType === 'student' ? 'bg-gradient-to-r from-blue-600 to-blue-800' : 'bg-gradient-to-r from-green-600 to-green-800'}`}>
            <div className="flex items-center justify-between mb-4">
              <span className={`text-xs font-medium px-3 py-1 rounded-full ${profileType === 'student' ? 'bg-blue-500 text-blue-100' : 'bg-green-500 text-green-100'}`}>
                {profileType === 'student' ? 'Student Profile' : 'Employee Profile'}
              </span>
              <button
                onClick={() => setSelectedProfile(null)}
                className="text-white opacity-70 hover:opacity-100 transition text-xl font-light"
              >
                ✕
              </button>
            </div>

            {/* Avatar */}
            <div className="flex items-center gap-4">
              <div className="w-16 h-16 rounded-full bg-white bg-opacity-20 flex items-center justify-center text-white text-2xl font-bold flex-shrink-0">
                {selectedProfile.name?.charAt(0).toUpperCase()}
              </div>
              <div>
                <h2 className="text-white text-xl font-bold">{selectedProfile.name}</h2>
                <p className="text-white text-opacity-80 text-sm mt-0.5">
                  {profileType === 'student' ? selectedProfile.studentId : selectedProfile.employeeId}
                </p>
                <p className="text-white text-opacity-70 text-xs mt-1">
                  {profileType === 'student' ? `${selectedProfile.department} · Year ${selectedProfile.year}` : `${selectedProfile.designation} · ${selectedProfile.department}`}
                </p>
              </div>
            </div>
          </div>

          {/* Profile Details */}
          <div className="p-6">
            <h3 className="text-sm font-semibold text-slate-400 uppercase tracking-wider mb-4">Personal Information</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-6">
              {profileType === 'student' ? (
                <>
                  <div className="bg-slate-50 rounded-xl p-3">
                    <p className="text-xs text-slate-400 mb-1">Full Name</p>
                    <p className="font-medium text-slate-800 text-sm">{selectedProfile.name || '-'}</p>
                  </div>
                  <div className="bg-slate-50 rounded-xl p-3">
                    <p className="text-xs text-slate-400 mb-1">Student ID</p>
                    <p className="font-medium text-slate-800 text-sm">{selectedProfile.studentId || '-'}</p>
                  </div>
                  <div className="bg-slate-50 rounded-xl p-3">
                    <p className="text-xs text-slate-400 mb-1">Gender</p>
                    <p className="font-medium text-slate-800 text-sm">{selectedProfile.gender || '-'}</p>
                  </div>
                  <div className="bg-slate-50 rounded-xl p-3">
                    <p className="text-xs text-slate-400 mb-1">Department</p>
                    <p className="font-medium text-slate-800 text-sm">{selectedProfile.department || '-'}</p>
                  </div>
                  <div className="bg-slate-50 rounded-xl p-3">
                    <p className="text-xs text-slate-400 mb-1">Year</p>
                    <p className="font-medium text-slate-800 text-sm">Year {selectedProfile.year || '-'}</p>
                  </div>
                  <div className="bg-slate-50 rounded-xl p-3">
                    <p className="text-xs text-slate-400 mb-1">Email</p>
                    <p className="font-medium text-slate-800 text-sm break-all">{selectedProfile.email || '-'}</p>
                  </div>
                  <div className="bg-slate-50 rounded-xl p-3 col-span-full">
                    <p className="text-xs text-slate-400 mb-1">Enrolled On</p>
                    <p className="font-medium text-slate-800 text-sm">{selectedProfile.createdAt ? selectedProfile.createdAt.split('T')[0] : '-'}</p>
                  </div>
                </>
              ) : (
                <>
                  <div className="bg-slate-50 rounded-xl p-3">
                    <p className="text-xs text-slate-400 mb-1">Full Name</p>
                    <p className="font-medium text-slate-800 text-sm">{selectedProfile.name || '-'}</p>
                  </div>
                  <div className="bg-slate-50 rounded-xl p-3">
                    <p className="text-xs text-slate-400 mb-1">Employee ID</p>
                    <p className="font-medium text-slate-800 text-sm">{selectedProfile.employeeId || '-'}</p>
                  </div>
                  <div className="bg-slate-50 rounded-xl p-3">
                    <p className="text-xs text-slate-400 mb-1">Gender</p>
                    <p className="font-medium text-slate-800 text-sm">{selectedProfile.gender || '-'}</p>
                  </div>
                  <div className="bg-slate-50 rounded-xl p-3">
                    <p className="text-xs text-slate-400 mb-1">Department</p>
                    <p className="font-medium text-slate-800 text-sm">{selectedProfile.department || '-'}</p>
                  </div>
                  <div className="bg-slate-50 rounded-xl p-3">
                    <p className="text-xs text-slate-400 mb-1">Designation</p>
                    <p className="font-medium text-slate-800 text-sm">{selectedProfile.designation || '-'}</p>
                  </div>
                  <div className="bg-slate-50 rounded-xl p-3">
                    <p className="text-xs text-slate-400 mb-1">Email</p>
                    <p className="font-medium text-slate-800 text-sm break-all">{selectedProfile.email || '-'}</p>
                  </div>
                  <div className="bg-slate-50 rounded-xl p-3">
                    <p className="text-xs text-slate-400 mb-1">Monthly Salary</p>
                    <p className="font-bold text-green-600 text-sm">₹{selectedProfile.salary?.toLocaleString() || '-'}</p>
                  </div>
                  <div className="bg-slate-50 rounded-xl p-3">
                    <p className="text-xs text-slate-400 mb-1">Joined On</p>
                    <p className="font-medium text-slate-800 text-sm">{selectedProfile.createdAt ? selectedProfile.createdAt.split('T')[0] : '-'}</p>
                  </div>
                </>
              )}
            </div>

            {/* Action Buttons */}
            <div className="flex gap-3 mt-2">
              <button
                onClick={() => {
                  setDeleteConfirm({
                    id: profileType === 'student' ? selectedProfile.studentId : selectedProfile.employeeId,
                    name: selectedProfile.name
                  });
                  setDeleteType(profileType);
                  setSelectedProfile(null);
                }}
                className="flex-1 px-4 py-2.5 bg-red-50 hover:bg-red-100 text-red-600 rounded-xl text-sm font-medium transition"
              >
                Delete {profileType === 'student' ? 'Student' : 'Employee'}
              </button>
              <button
                onClick={() => setSelectedProfile(null)}
                className="flex-1 px-4 py-2.5 bg-slate-100 hover:bg-slate-200 text-slate-600 rounded-xl text-sm font-medium transition"
              >
                Close
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  </div>
)}

        {/* Delete Confirmation Modal */}
{deleteConfirm && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6">
      <div className="text-center mb-6">
        <div className="text-5xl mb-3">⚠️</div>
        <h2 className="text-xl font-bold text-slate-800">Confirm Deletion</h2>
        <p className="text-slate-500 text-sm mt-2">
          This action cannot be undone. All records for this {deleteType} will be permanently deleted from the database.
        </p>
      </div>

      <div className="bg-red-50 border border-red-200 rounded-xl p-4 mb-6">
        <p className="text-sm font-medium text-red-700">You are about to delete:</p>
        <p className="text-lg font-bold text-red-800 mt-1">{deleteConfirm.name}</p>
        <p className="text-sm text-red-600">{deleteConfirm.id}</p>
      </div>

      <p className="text-sm text-slate-500 text-center mb-6">
        Are you absolutely sure you want to delete this {deleteType}?
      </p>

      <div className="flex gap-3">
        <button
          onClick={() => { setDeleteConfirm(null); setDeleteType(''); }}
          className="flex-1 px-4 py-3 border border-slate-200 text-slate-600 rounded-xl text-sm font-medium hover:bg-slate-50 transition"
        >
          Cancel
        </button>
        <button
          onClick={handleDelete}
          className="flex-1 px-4 py-3 bg-red-600 hover:bg-red-700 text-white rounded-xl text-sm font-medium transition"
        >
          Yes, Delete Permanently
        </button>
      </div>
    </div>
  </div>
)}


{showLogoutModal && (
  <LogoutModal
    onConfirm={() => { setShowLogoutModal(false); handleLogout(); }}
    onCancel={() => setShowLogoutModal(false)}
  />
)}

    </div>
  );
}

export default AdminDashboard;